// Non-personal presentation constants shared by the application.
export const ANNO_CORRENTE = 2026;

export const RUOLI = [
  { id: 'ceo', nome: 'Founder/CEO', descrizione: 'Proprietario piattaforma. Modalità DEV per simulare altri ruoli.', livello: 5, colore: 'bg-emerald-100 text-emerald-900' },
  { id: 'titolare', nome: 'Titolare', descrizione: 'Gestisce tutto il proprio tenant: aziende, locali e reparti.', livello: 4, colore: 'bg-amber-100 text-amber-900' },
  { id: 'resp_generale', nome: 'Responsabile Generale', descrizione: 'Solo scope autorizzato (più locali della stessa azienda).', livello: 3, colore: 'bg-blue-100 text-blue-900' },
  { id: 'resp_locale', nome: 'Responsabile Locale', descrizione: 'Solo il proprio locale/reparto.', livello: 2, colore: 'bg-blue-100 text-blue-800' },
  { id: 'segretaria', nome: 'Segretaria', descrizione: 'Anagrafica, contratti, registro ferie dove autorizzata.', livello: 1, colore: 'bg-red-100 text-red-800' },
  { id: 'dipendente', nome: 'Dipendente', descrizione: 'Solo i propri dati e le proprie richieste.', livello: 0, colore: 'bg-stone-100 text-stone-900' },
];

export const REPARTI = ['Cucina'];
